import { useEffect, useState } from 'react'
import {
  COUNTDOWN_SECONDS,
  COUNTDOWN_INTERVAL_MS,
} from '@/shared/constants/timings'

export function useResendOtp(onResend: () => void) {
  const [seconds, setSeconds] = useState(COUNTDOWN_SECONDS)

  useEffect(() => {
    if (seconds === 0) return
    const timer = setTimeout(
      () => setSeconds((s) => s - 1),
      COUNTDOWN_INTERVAL_MS,
    )
    return () => clearTimeout(timer)
  }, [seconds])

  function handleResend() {
    onResend()
    setSeconds(COUNTDOWN_SECONDS)
  }

  const formatted = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`

  return { formatted, handleResend, seconds }
}
